import { CircularProgress } from '@asicsdigital/adi-blocks-core';
import { styled } from '@asicsdigital/oneasics-blocks';

const StyledCircularProgress = styled(CircularProgress) ({
  height: '16px',
  width: '16px',
  marginInlineEnd: '8px',
});

const Spinner = <StyledCircularProgress color="inherit" size="16" />;

export default Spinner;
